import { Typography, Box, Stack } from '@mui/material';
import { WhyWallfundProps } from '@/containers/home/components/WhyWallfund';
const WhyWallfundItem = ({
  icon,
  title,
  description,
  width
}: WhyWallfundProps): JSX.Element => {
  return <Stack gap='var(--spacing_s)' sx={{
    bgcolor: 'background.bg',
    width: {
      xs: '100%',
      md: width
    },
    padding: 'var(--spacing_m)',
    borderRadius: 'var(--corner_radius_xl)'
  }} data-sentry-element="Stack" data-sentry-component="WhyWallfundItem" data-sentry-source-file="WhyWallfundItem.tsx">
      <Box sx={{
      lineHeight: 0,
      fontSize: {
        xs: 72,
        md: 100
      }
    }} padding='var(--spacing_xs)' data-sentry-element="Box" data-sentry-source-file="WhyWallfundItem.tsx">
        {icon}
      </Box>
      <Stack data-sentry-element="Stack" data-sentry-source-file="WhyWallfundItem.tsx">
        <Typography color='primaryBrand.grad.dark' typography={{
        xs: 'bodyLargeStrong__Wallfund',
        md: 'headlineStrong__Wallfund'
      }} data-sentry-element="Typography" data-sentry-source-file="WhyWallfundItem.tsx">
          {title}
        </Typography>
        <Typography typography={{
        xs: 'bodyRegular__Wallfund',
        md: 'bodyLargeRegular__Wallfund'
      }} data-sentry-element="Typography" data-sentry-source-file="WhyWallfundItem.tsx">
          {description}
        </Typography>
      </Stack>
    </Stack>;
};
export default WhyWallfundItem;